(function () {
    angular.module('invesfleet')
        .directive('date', date);

    date.$inject = ['$timeout','$filter', 'common'];

    function date($timeout,$filter, common) {

        return {
            restrict: 'EA',
            templateUrl: 'app/views/directives/dateInput.html',
            scope: {
                ngModel: '=',
                ngChange: '&?',
                seconds: '<',
                ngDisabled: '=',
                autofocus: '<',
                autoInit: '<',
                ngMin: '=?',
                ngMax: '=?',
                showTime: '<?'
            },
            link: function (scope, element, attrs) {

                var changedFromInput = false;

                if (typeof scope.seconds === 'undefined') {
                    scope.seconds = true;
                }
                if (!scope.autofocus) {
                    scope.autofocus = false;
                } else {
                    scope.autofocus = true;
                }

                if (common.isNullOrUndefined(scope.showTime))
                    scope.showTime = true;


                //INICIALIZAR CON FECHA ACTUAL
                if (scope.autoInit) {
                    scope.ngModel = Date.NewDate();
                }

                scope.$watch('ngModel', function (newVal, oldVal) {
                    if(changedFromInput){
                        //We dont need to set the input because the change comes from it
                        changedFromInput = false;
                    } else {
                        setPartsFromModel();
                    }
                    if(scope.ngChange){ scope.ngChange(); }
                });

                scope.onChangeDate = function () {
                    setModelFromParts();
                };

                scope.onChangeTime = function () {
                    setModelFromParts();
                };

                function setModelFromParts() {
                    changedFromInput = true;
                    if (!scope.internalDate) {
                        scope.ngModel = null;
                    } else {
                        var year = scope.internalDate.getFullYear();
                        var month = scope.internalDate.getMonth();
                        var date = scope.internalDate.getDate();

                        var now = Date.NewDate();
                        var hour = compareDates(scope.internalDate, now) ? now.getHours() : 0;
                        var min = compareDates(scope.internalDate, now) ? now.getMinutes() : 0;
                        var sec = compareDates(scope.internalDate, now) ? now.getSeconds() : 0;
                        if (scope.internalTime) {
                            hour = scope.internalTime.getHours();
                            min = scope.internalTime.getMinutes();
                            sec = scope.internalTime.getSeconds();
                        }

                        scope.ngModel = new Date(year, month, date, hour, min, sec);
                    }
                }

                function setPartsFromModel() {
                    scope.internalDate = getProcessedDate(scope.ngModel);
                    scope.internalTime = getProcessedDate(scope.ngModel);
                }

                function getProcessedDate(date) {
                    if (!date) {
                        return null;
                    }
                    var d = new Date(date);
                    if (d && scope.seconds === false && d.getSeconds() > 0) {
                        d = new Date(d.setSeconds(0));
                    }
                    if (d && d.getMilliseconds() > 0) {
                        d = new Date(d.setMilliseconds(0));
                    }
                    return d;
                }

                function compareDates(date1, date2){
                    if(!date1 || !date2) { return false; }
                    return date1.getFullYear() === date2.getFullYear() &&
                        date1.getMonth() === date2.getMonth() &&
                        date1.getDate() === date2.getDate();
                }
            }
        };
    }
})();